module.exports = __webpack_public_path__ + "static/media/unpleasantSurprise--1.a6093ea0.png";